import { TableColumn } from 'react-data-table-component';

import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { PaymentStatusDetailDataForm, PaymentStatusDetailFilters } from '../../../../app/models/PaymentStatusDetail';
import { momentParseDate } from '../../../../helpers';
import { formatAmount, formatMoney } from '../../../../utils/utils';


interface Props {
    paymentStatusDetails: PaymentStatusDetailDataForm[];
    totalRows: number;
    loading?: boolean;
    filter: PaymentStatusDetailFilters;
    setFilter: (filter: PaymentStatusDetailFilters) => void;
    paymentStatusCurrency?: string;
}

const PaymentStatusDetailDataTable = ({
    paymentStatusDetails,
    totalRows,
    loading = false,
    filter,
    setFilter,
    paymentStatusCurrency
}: Props) => {
    const columns: TableColumn<PaymentStatusDetailDataForm>[] = [
        {
            name: 'Pos',
            width: '120px',
            sortable: false,
            cell: (row, index) => <span className=""> {index + 1}</span>
        },
        {
            name: 'Tramo',
            width: '120px',
            selector: (row) => row.route_segment_id ?? 0,
            sortable: true,
            sortField: 'route_segment_id',
            cell: (row) => <span className="">{row.route_segment_id}</span>
        },
        {
            name: 'Origen',
            selector: (row) => row.origin_name ?? '',
            sortable: true,
            sortField: 'origin_name',
            cell: (row) => row.origin_name ?? ''
        },
        {
            name: 'Destino',
            selector: (row) => row.destiny_name ?? '',
            sortable: true,
            sortField: 'destiny_name',
            cell: (row) => row.destiny_name ?? ''
        },
        {
            name: 'Producto',
            selector: (row) => row.product_name ?? '',
            sortable: true,
            sortField: 'product_name',
            cell: (row) => row.product_name ?? ''
        },
        {
            name: 'Fecha de Despacho',
            selector: (row) => row.dispatch_date ?? '',
            sortable: true,
            sortField: 'dispatch_date',
            cell: (row) => <span className="">{momentParseDate(row.dispatch_date)}</span>
        },     
        {
            name: 'Tarifa',
            selector: (row) => row.rate ?? 0,
            sortable: true,
            sortField: 'rate',
            cell: (row) => {
                if (!row.rate) return <span className=""></span>;
                const currency = paymentStatusCurrency || row?.currency_rate || 'CLP';
                const unit = row?.unit_rate ?? '';
                const rateValue = Number(row.rate).toLocaleString('de-DE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                return (
                    <span className="">
                        {rateValue} {currency}{unit ? `/${unit}` : ''}
                    </span>
                );
            }
        },
        {
            name: 'Cantidad',
            selector: (row) => row.quantity ?? 0,
            sortable: true,
            sortField: 'quantity',
            cell: (row: PaymentStatusDetailDataForm) => {
                const quantityLabel = row.quantity ? `${formatAmount(Number(row.quantity))} ${row?.unit_quantity ?? ''}` : '';
                const standardParens =
                    row.standard_weight_applied && row.billed_quantity != null
                        ? ` (${formatAmount(Number(row.billed_quantity))})`
                        : '';

                return (
                    <span
                        className=""
                        title={
                            row.standard_weight_applied && row.billed_quantity != null
                                ? `Cantidad facturada (peso padrón): ${formatAmount(Number(row.billed_quantity))}`
                                : undefined
                        }
                    >
                        {quantityLabel}
                        {standardParens}
                    </span>
                );
            }
        },
        
        {
            name: 'Monto Total',
            selector: (row) => row.total_amount ?? 0,
            sortable: true,
            sortField: 'total_amount',
            cell: (row) => (
                <span className="">{row.total_amount ? formatMoney(row.total_amount, row?.currency_rate ?? 'CLP') : ''}</span>
            )
        },
        {
            name: 'Val. Moneda Local (CLP)',
            selector: (row) => row.local_currency_amount ?? 0,
            sortable: true,
            sortField: 'local_currency_amount',
            cell: (row) => (
                <span className="">{row.local_currency_amount != null ? formatMoney(row.local_currency_amount, 'CLP') : '-'}</span>
            )
        },
       
    ];

    return (
        <>

            <DefaultDataTable
                columns={columns}
                data={paymentStatusDetails}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default PaymentStatusDetailDataTable;
